export class BrokerRefreshInvalidGrantError extends Error {
  constructor(readonly credentialInstanceId: string) {
    super(
      `Credential ${credentialInstanceId}: refresh token is invalid or revoked (invalid_grant). Reconnect required.`,
    );
    this.name = "BrokerRefreshInvalidGrantError";
  }
}
